import { render, staticRenderFns } from "./NeedsDashboardSidebar.vue?vue&type=template&id=8c32e744&scoped=true&"
import script from "./NeedsDashboardSidebar.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsDashboardSidebar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c32e744",
  null
  
)

export default component.exports